const map = {
	"./admission/additionalTest/router.js": 16431,
	"./admission/applicantsList/router.js": 45603,
	"./admission/config/router.js": 24794,
	"./admission/fisGIA/router.js": 1911,
	"./admission/importEService/router.js": 63916,
	"./admission/router.js": 13280,
	"./admission/statistic/router.js": 93167,
	"./clientsInfo/router.js": 54487,
	"./dictionaries/certificateSubjects/router.js": 6723,
	"./dictionaries/militaryOffice/router.js": 50013,
	"./dictionaries/router.js": 65611,
	"./documents3/router.js": 85103,
	"./errorlog/router.js": 6173,
	"./export/router.js": 95396,
	"./export/torMySchool/router.js": 37536,
	"./gradesBook2/practicalTraining/router.js": 2145,
	"./gradesBook2/router.js": 74120,
	"./plan3/disciplines/router.js": 77024,
	"./plan3/router.js": 20795,
	"./reportsLocal/attendanceStudentsReport/router.js": 71674,
	"./reportsLocal/router.js": 49077,
	"./reportsLocal/summaryMissedHours/router.js": 89595,
	"./router.js": 27182,
	"./secretariat/alphabetBook/router.js": 21711,
	"./secretariat/attendanceReport/router.js": 5920,
	"./secretariat/router.js": 56094,
	"./secretariat/studentCard/router.js": 79724,
	"./secretariat/students/router.js": 3808,
	"./service/router.js": 55002,
	"./service/settingsImportExport/router.js": 77370,
	"./tariffication/router.js": 51314,
	"./tariffication/versionTariffication/router.js": 11018,
	"./timetable2/importCity/router.js": 76266,
	"./timetable2/router.js": 87850,
	"./timetable2/teacher/router.js": 26386
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23408;